import React, { Component } from 'react';
import 'whatwg-fetch';
class getTimerAgente extends Component {
  constructor(props){
    super(props);
    }
//componentDidMount
 componentWillUnmount () {
   clearInterval(this.timer)
 }

getPedidos =()=>{
  
  const id_tipo_permiso = this.props.id_tipo_permiso
  const usuario = this.props.usuario

  if(Number(id_tipo_permiso)!==4) return
  const url= this.props.dir_url + "webapp/getAgente";
  const token =  this.props.token
  var obj = { accion:'agente', token,usuario};
  fetch(url, {
    method: 'POST',
    body: JSON.stringify(obj),
    headers:{
      'Accept':'application/json',
      'Content-Type': 'application/json'
    }
  })
  .then(res => res.json())
  .then((data) => {
    if(data[0].status==="ok"){
       //console.log("AGENTE")
       this.props.abrir_call(data[0].msg[0].telefono)
    }
  })
  .catch(console.log)
}
 tick () {
  this.getPedidos()
 }
 startTimer () {
   clearInterval(this.timer)
   this.timer = setInterval(this.tick.bind(this), 2000)
 }
 stopTimer () {
   clearInterval(this.timer)
 }
 render () {
   return (
     <React.Fragment></React.Fragment>
   )
 }
 componentDidMount (){
    this.getPedidos();
    //console.log("ddd")
    this.startTimer();
 }
}
export default getTimerAgente;
